import { useEffect, useState } from "react";
import {
  Outlet,
  useNavigate,
} from "../node_modules/react-router-dom/dist/index";
import Header from "./components/header/Header";
import s from "./style.module.css";
import { ActivatedNameContext } from "./components/contexts/ActivatedNameContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { config } from "./config";

export default function App() {
  const [activatedName, setActivatedName] = useState("");

  useEffect(() => {
    const preloadImages = (imageUrls) => {
      imageUrls.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    };

    const iconsCompetences = [
      `${config.BASE_URL}/assets/iconsExperiences/angular.webp`,
      `${config.BASE_URL}/assets/iconsExperiences/bdd.webp`,
      `${config.BASE_URL}/assets/iconsExperiences/bootstrap.webp`,
      `${config.BASE_URL}/assets/iconsExperiences/docker.webp`,
      `${config.BASE_URL}/assets/iconsExperiences/github.webp`,
      `${config.BASE_URL}/assets/iconsExperiences/java.webp`,
      `${config.BASE_URL}/assets/iconsExperiences/node.webp`,
      `${config.BASE_URL}/assets/iconsExperiences/react.webp`,
      `${config.BASE_URL}/assets/iconsExperiences/spring.webp`,
      `${config.BASE_URL}/assets/codeLines.webp`,
    ];

    const onLoad = () => {
      preloadImages(iconsCompetences);
    };

    window.addEventListener("load", onLoad);
    return () => {
      window.removeEventListener("load", onLoad);
    };
  }, []);

  const [bigScreen, setBigScreen] = useState(window.innerWidth > 2000);
  useEffect(() => {
    const handleResize = () => {
      setBigScreen(window.innerWidth > 2000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();
  const navigateToMentionsLegales = () => {
    setActivatedName("");
    navigate("/mentions-legales");
    window.scrollTo(0, 0);
  };

  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LdJIXkqAAAAAIBqpf_fOOSR2axp8_cqZxR0mnUl">
      <ActivatedNameContext.Provider
        value={{ activatedName, setActivatedName }}
      >
        <div className={`${s.container}`}>
          <div className={`${s.header}`}>
            <Header bigScreen={bigScreen} />
          </div>
          <div className={s.body}>
            <div className={`${bigScreen ? s.containerLarge : "container"}`}>
              <div className={`${s.row} row`}>
                <Outlet />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-end">
            <div onClick={navigateToMentionsLegales} className={s.legalLink}>
              Mentions Légales
            </div>
          </div>
        </div>
      </ActivatedNameContext.Provider>
    </GoogleReCaptchaProvider>
  );
}
